import PropTypes from 'prop-types';
import React from 'react';

/**
 *  Render "Sponsored" as inline SVG in order to avoid ad blockers
 *
 */
function SponsoredText(_ref) {
  let {
    className = 'text-size-100',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), "Sponsored");
}
export default SponsoredText;